import { m } from '@sohanscript/i18n';
import { useParams } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { PageBreadcrumb } from '@/components/page-breadcrumb';
import { api } from '@/lib/trpc/client';

type WorkBreadcrumbProps = ComponentProps<'div'>;

export function WorkBreadcrumb({ ...props }: WorkBreadcrumbProps) {
	const { slug } = useParams({ from: '/_main/work/$slug' });
	const [allSlugs] = api.project.allSlugs.useSuspenseQuery();

	const items = (allSlugs ?? []).map((p) => ({
		slug: p.slug?.current ?? '',
		title: p.title ?? '',
	}));

	return (
		<PageBreadcrumb
			currentSlug={slug}
			currentTitle={allSlugs?.find((p) => p.slug?.current === slug)?.title}
			listTo="/works"
			listLabel={m.work_all()}
			itemTo="/work/$slug"
			items={items}
			{...props}
		/>
	);
}
